import LayoutIndex from '@/layout/LayoutIndex.vue'

const inspectionsRouter = [
  {
    path: '/inspections',
    component: LayoutIndex,
    meta: { title: '检测管理', icon: 'inspections', requireAuth: true },
    name: 'inspections',
    redirect: '/inspections/Incoming',
    children: [
      {
        path: '/inspections/InspectionType',
        component: () => import('@/views/inspections/inspectionTypes/inspectionTypeList.vue'),
        name: 'inspectionTypeList',
        meta: { title: '检验类型', requireAuth: false }
      },
      {
        path: '/inspections/Inspection',
        component: () => import('@/views/inspections/inspection/inspectionsList.vue'),
        name: 'inspectionsList',
        meta: { title: '检验项目', requireAuth: false }
      },
      {
        path: '/inspections/qualityPlan',
        component: () => import('@/views/inspections/qualityPlans/qualityPlan.vue'),
        name: 'qualityPlans',
        meta: { title: '质检方案', requireAuth: false }
      },
      {
        path: '/inspections/qualityPlan/form',
        name: 'QualityPlanForm',
        component: () => import('@/views/inspections/qualityPlans/model/EditQualityPlan.vue'),
        meta: { title: '质检方案编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/inspections/Incoming',
        component: () => import('@/views/inspections/Incomings/IncomingList.vue'),
        name: 'IncomingList',
        meta: { title: '来料检验', requireAuth: false }
      },
      {
        path: '/inspections/Incoming/todo',
        component: () => import('@/views/inspections/Incomings/IncomingTodoList.vue'),
        name: 'IncomingTodoList',
        meta: { title: '检验闭环待办', requireAuth: false }
      },
      {
        path: '/inspections/Incoming/boxcodes',
        component: () => import('@/views/inspections/Incomings/IncomingBoxCodeList.vue'),
        name: 'IncomingBoxCodeList',
        meta: { title: '来料箱码台账', requireAuth: false }
      },
      {
        path: '/inspections/Incoming/model',
        component: () => import('@/views/inspections/Incomings/model/AddIncoming.vue'),
        name: 'AddIncoming',
        meta: { title: '来料检验编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/inspections/Incoming/process',
        component: () => import('@/views/inspections/Incomings/model/IncomingProcess.vue'),
        name: 'IncomingProcess',
        meta: { title: '来料检验处理', requireAuth: false },
        hidden: true
      },
      {
        path: '/inspections/Incoming/station',
        component: () => import('@/views/inspections/Incomings/station/IncomingStation.vue'),
        name: 'IncomingStation',
        meta: { title: '来料工位', requireAuth: false },
        hidden: true
      }
    ]
  }
]

export default inspectionsRouter
